import CheckBox from './checkbox.vue';
import CheckGroupBox from './checkgroupbox.vue';
export {CheckBox,CheckGroupBox};


// WEBPACK FOOTER //
// ./src/components/checkbox/index.js